import { render, staticRenderFns } from "./Inventario.vue?vue&type=template&id=a822bcc0&scoped=true"
import script from "./Inventario.vue?vue&type=script&lang=js"
export * from "./Inventario.vue?vue&type=script&lang=js"
import style0 from "./Inventario.vue?vue&type=style&index=0&id=a822bcc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a822bcc0",
  null
  
)

export default component.exports